/**
 * A class for handling the responsive behavior of the menu, adjusting its structure
 * for desktop and mobile views based on viewport width.
 *
 * @class
 */
class ResponsiveMenu {

	/**
	 * Initializes the class
	 */
	constructor() {

		// Get the button and the component it controls
		this.menuButton = document.getElementById( 'header-btn-menu' );
		this.menuComponent = document.getElementById( this.menuButton.getAttribute( 'aria-controls' ) );

		// Set up the initial media query check
		this.mediaQuery = window.matchMedia( '(min-width: 1201px)' );

		// Bind the resize event and initial check
		this.handleViewportChange( this.mediaQuery ); // Run once on load
		this.mediaQuery.addEventListener( 'change', ( event ) => this.handleViewportChange( event ) ); // Run on resize

	}

	/**
	 * Handles viewport changes and applies the appropriate structure for desktop or mobile.
	 *
	 * @param {MediaQueryList} mediaQuery - The media query object.
	 */
	handleViewportChange( mediaQuery ) {

		if ( mediaQuery.matches ) {

			// Desktop view
			this.applyDesktopStructure();

		} else {

			// Mobile view
			this.applyMobileStructure();

		}

	}

	/**
	 * Applies the structure for desktop (removes mobile attributes)
	 */
	applyDesktopStructure() {

		this.menuComponent.removeAttribute( 'hidden' );
		this.menuComponent.removeAttribute( 'aria-labelledby' );

	}

	/**
	 * Applies the structure for mobile (adds mobile attributes)
	 */
	applyMobileStructure() {

		this.menuComponent.setAttribute( 'hidden', '' );
		this.menuComponent.setAttribute( 'aria-labelledby', this.menuButton.id );

	}

}
export default ResponsiveMenu;


